import React, { useState, useEffect } from 'react';
import { Link, Navigate } from 'react-router-dom'; // Import Navigate for redirection
import './SettingsPage.css'; 
import AddRoom from './AddRoom';
import AdminRooms from './AdminRooms';
import ReservationsManagement from './ReservationsManagement';

const SettingsPage = () => {
  // State to manage the selected page in the settings section
  const [selectedPage, setSelectedPage] = useState('add-room');
  const [isAuthenticated, setIsAuthenticated] = useState(true); // State to manage authentication status

  // Check if a token exists in localStorage when the component mounts
  useEffect(() => {
    const token = localStorage.getItem('token'); // Replace with your storage mechanism
    console.log(token)
    if (!token) {
      setIsAuthenticated(false); // If no token, set to false
    }
  }, []);

  // If the user is not authenticated, redirect to the login page
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  // Function to change selected page
  const handleNavClick = (page) => {
    setSelectedPage(page);
  };
  return (
    <div className="settings-container">
      {/* Navigation Sidebar */}
      <nav className="settings-nav">
        <ul>
          <li>
            <Link
              to="/dashboard"
              className="nav-link"
              onClick={() => handleNavClick('add-room')}
            >
              Add Room
            </Link>
          </li>
          <li>
            <Link
              to="/dashboard"
              className="nav-link"
              onClick={() => handleNavClick('manage-rooms')}
            >
              Manage Rooms
            </Link>
          </li>
          <li>
            <Link
              to="/dashboard"
              className="nav-link"
              onClick={() => handleNavClick('reservations')}
            >
              Reservations
            </Link>
          </li>
          <li>
            <Link
              to="/dashboard"
              className="nav-link"
              onClick={() => handleNavClick('update-content')}
            >
              Update Content
            </Link>
          </li>
        </ul>
      </nav>

      {/* Main Content Area */}
      <div className="settings-content">
        {/* Conditionally render components based on selectedPage */}
        {selectedPage === 'add-room' && <AddRoom />}
        {selectedPage === 'manage-rooms' && <AdminRooms />}
        {selectedPage === 'reservations' && <ReservationsManagement />}
        {/* You can add another component here for Update Content */}
      </div>
    </div>
  );
};

export default SettingsPage;
